export default {
  queuedJobLogs: []
}
